import "../css/style.css"

import { modal } from "./modules/modal"
import { header } from "./modules/header"
import { sliders } from "./modules/sliders"
import { timeline } from "./modules/timeline"
import { expandable } from "./modules/expandable"
import { scroll } from "./modules/scroll"
import { images } from "./modules/images"
import { submitGuard } from "./modules/submitGuard"

window.PortBlakely = {}

const afterLoad = () => {
    modal.init()
    sliders.init()
    timeline.init()
    expandable.init()
    scroll.init()
    header.init()
    images.init()
    submitGuard.init()
}

// Ensure the DOM is fully loaded before initializing
window.addEventListener("load", afterLoad)